import React from 'react';
import './PageLoader.css';

interface PageLoaderProps {
  /** Optional message to display below the loader */
  message?: string;
  /** Size variant of the loader */
  size?: 'sm' | 'md' | 'lg';
  /** Whether to show as a full-page overlay */
  fullPage?: boolean;
  /** Minimum height when not full page */
  minHeight?: string;
}

/**
 * Unified page loader component for consistent loading experience
 * across all sidebar navigation routes.
 */
const PageLoader: React.FC<PageLoaderProps> = ({
  message,
  size = 'md',
  fullPage = true,
  minHeight = '100vh',
}) => {
  const sizeClass = `page-loader--${size}`;
  const containerClass = fullPage ? 'page-loader--fullpage' : 'page-loader--inline';

  return (
    <div 
      className={`page-loader ${containerClass}`}
      style={!fullPage ? { minHeight } : undefined}
      role="status"
      aria-live="polite"
      aria-label={message || 'Loading content'}
    >
      <div className="page-loader__content">
        {/* Animated logo/spinner */}
        <div className={`page-loader__spinner ${sizeClass}`}>
          <div className="page-loader__ring"></div>
          <div className="page-loader__ring page-loader__ring--delayed"></div>
          <div className="page-loader__dot"></div>
        </div>
        
        {/* Loading message */}
        {message && (
          <p className="page-loader__message">{message}</p>
        )}
        
        {/* Subtle loading indicator bar */}
        <div className="page-loader__progress">
          <div className="page-loader__progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default PageLoader;
